import BackgroundVideo from './BackgroundVideo';
import OnboardingSequence from './step1/OnboardingSequence';
import LogoBar from './LogoBar';
import Vault from './Vault';
import WarningBar from './WarningBar';
import useOnboardingStore from 'stores/onboardingStore';

const Onboarding = () => {
  const { showInputSequence } = useOnboardingStore();

  return (
    <div className="grid w-full h-full place-content-center">
      <BackgroundVideo />
      <Vault />

      <div className="grid grid-rows-[auto_auto_1fr] gap-[8px] absolute top-0 left-0 w-screen h-full text-center justify-center">
        <WarningBar />
        <LogoBar />
        {showInputSequence && <OnboardingSequence />}
      </div>
    </div>
  );
};

export default Onboarding;
